import * as React from "react";
import type { SVGProps } from "react";
const SvgImage02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.8 21.6h14.4c1.326 0 2.4-1.131 2.4-2.526V4.926c0-1.395-1.075-2.526-2.4-2.526H4.8c-1.325 0-2.4 1.131-2.4 2.526v14.148c0 1.395 1.075 2.526 2.4 2.526"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 15.6h12l-4-7-3 4.5-2-2z"
    />
  </svg>
);
export default SvgImage02;
